module.exports = __webpack_public_path__ + "c7b6ca0ba6f7b05ae62a3ba909599020.jpg";